import ROUTES from "@config/routes";

export enum LegacyTypesPermissions {
  PORTAL_CLIENTE = "portal_cliente",
  CIF_DRIVER = "cif_driver",
  HOME = "portal_cliente:home:*",
  GOALS_AND_COMMISSIONS = "portal_cliente:goals_and_commissions:*",
  PERFORMANCE_MANAGEMENT = "portal_cliente:performance_management:*",
  CAMPAIGN_METRICS = "portal_cliente:campaign_metrics:*",
  ANNOUCEMENTS = "portal_cliente:announcements:*",
  CONTACT = "portal_cliente:contact:*",
  CHANGE_PASSWORD = "portal_cliente:change_password:*",
  SIMULATION = "portal_cliente:simulation:*",
  EMPLOYEE = "portal_cliente:employee:*",
  COLETA = "portal_cliente:coleta:*",
  NOZZLES = "portal_cliente:nozzles:*",
  PRODUCT_PRICE = "portal_cliente:product_price:*",
  DRIVER_CUSTOMER = "portal_cliente:driver_customer:*",
  ORDER = "portal_cliente:orders:*",
  APPOINTMENTS_TITLE = "portal_cliente:appointments_titles:*",
  APPOINTMENTS_INVOICES = "portal_cliente:appointments_invoices:*",
  DRIVER = "portal_cliente:driver:*",
  DISCOUNT = "portal_cliente:driver:*",
  CARRIER = "portal_cliente:carrier:*",
  NOTIFICATIONS = "portal_cliente:notifications:*",
}

export const legacyPermissionRouteMap: Record<string, string> = {
  [LegacyTypesPermissions.HOME]: ROUTES.USER_ROUTES.HOME,
  [LegacyTypesPermissions.DRIVER]: ROUTES.USER_ROUTES.ROADLOAD,
  [LegacyTypesPermissions.CARRIER]: ROUTES.USER_ROUTES.ROADLOAD,
  [LegacyTypesPermissions.EMPLOYEE]: ROUTES.USER_ROUTES.EMPLOYEE,
  [LegacyTypesPermissions.GOALS_AND_COMMISSIONS]:
    ROUTES.USER_ROUTES.GOALS_AND_COMMISSIONS,
  [LegacyTypesPermissions.NOZZLES]: ROUTES.USER_ROUTES.NOZZLE,
  [LegacyTypesPermissions.COLETA]: ROUTES.USER_ROUTES.SALES,
  [LegacyTypesPermissions.PERFORMANCE_MANAGEMENT]:
    ROUTES.USER_ROUTES.PERFORMANCE_MANAGEMENT,
  [LegacyTypesPermissions.CAMPAIGN_METRICS]: ROUTES.USER_ROUTES.DASH_POSH,
  [LegacyTypesPermissions.SIMULATION]: ROUTES.USER_ROUTES.SIMULATE_ORDER,
  [LegacyTypesPermissions.PRODUCT_PRICE]: ROUTES.USER_ROUTES.APPOINTMENT_PRICE,
};
